export class HoopsAuth {

    public readonly uid: string;
    public readonly displayName: string | null;
    public readonly photoURL: string | null
    public readonly email: string | null
    public readonly emailVerified: boolean;
    public readonly isAdmin: boolean;

    constructor(
        uid: string,
        displayName: string | null,
        photoURL: string | null,
        email: string | null,
        emailVerified: boolean,
        isAdmin: boolean,
    ) {
        this.uid = uid;
        this.displayName = displayName;
        this.photoURL = photoURL;
        this.email = email;
        this.emailVerified = emailVerified;
        this.isAdmin = isAdmin;
    }
}

